import { LightBox } from "../../modules/lightbox/LightBox.js";
import { SliderSimple } from "./views/SliderSimple-front.js";


const SLIDERS = {SliderSimple};

/**
 * Gère slider
 */
export class Slider{
    static instances = [];
    /**
     * Recherche dans une page tous les sliders et dispatche selon le type
     * !!!! chaque slider doit posséder un id
     * @param {string} type 
     */
    static init(type){
        const $sliders = [...document.querySelectorAll(`.slider[data-slidertype=${type}]`)];
        if($sliders.length > 0){
            $sliders.forEach(($slider, i) => {
                const options = {};
                // ajout id ?
                if(typeof $slider.id === "string" && $slider.id.length > 0)
                    $slider.id = type+"-"+i;
                // options
                const {duration, hasdyncontent, uselightbox} = $slider.dataset;
                options.id            = $slider.id; 
                options.useLightbox   = uselightbox === "true";
                options.duration      = +duration;
                options.hasDynContent = hasdyncontent === "true";
                // instance
                const slider = new SLIDERS[type]($slider, options);
                /* if(hasDynContent){
                    $slider.addEventListener("postsloaded", e=>slider.create(), true);
                } else {
                    slider.create();
                } */
                if(uselightbox) 
                    LightBox.add(slider.getDom("PLAYER_CONTAINER"), "md");//////////////////////// ajouter attribut breakpoint dans slider jsx !!!!
                Slider.instances.push(slider);
            });
        }
    }

    /**
     * Renvoie l'instance de Slider par son Id
     * @param {string} id 
     * @returns {Slider|false}
     */
    static getById(id){
        return Slider.instances.find(instance => instance.id === id) || false;
    }

    static remove(){
        //
    }

}